import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    &,
    &:before,
    &:after {
      box-sizing: inherit;
    }
  }
  :focus {
    outline: 0;
  }
  ul {
    list-style: none;
  }
  strong {
    font-weight: ${props => props.theme.font.weight.bold};
  }
  /* Layout */
  html {
    box-sizing: border-box;
    font: ${props => props.theme.font.scale} "primary", "secondary", sans-serif;
    /* Changes for html and av-player if player is visible */
    &.isPlayerVisible {
      height: 100%;
      #av-player {
        display: block
      }
    }
  }
  body {
    overflow: hidden;
    /* Changes if player is visible */
    .isPlayerVisible & {
      height: 100%;
      transform: translateZ(0);
      background-color: transparent;
    }
  }
`;
